import {
  ADD_AREA_ENTRY_STRATEGY,
  ADD_AREA_ENTRY_STRATEGY_SUCCESSFUL,
  ADD_AREA_ENTRY_STRATEGY_FAILED,
} from './actionTypes';

const initialState = {
  addAreaEntryStrategyError: null,
  messageAddAreaEntryStrategy: null,
  loadingAddAreaEntryStrategy: false,
};

const addAreaEntryStrategy = (state = initialState, action) => {
  switch (action.type) {
    case ADD_AREA_ENTRY_STRATEGY:
      state = {
        ...state,
        loadingAddAreaEntryStrategy: true,
        addAreaEntryStrategyError: null,
      };
      break;
    case ADD_AREA_ENTRY_STRATEGY_FAILED:
      state = {
        ...state,
        messageAddAreaEntryStrategy: null,
        loadingAddAreaEntryStrategy: false,
        addAreaEntryStrategyError: action.payload,
      };
      break;
    case ADD_AREA_ENTRY_STRATEGY_SUCCESSFUL:
      state = {
        ...state,
        loadingAddAreaEntryStrategy: false,
        messageAddAreaEntryStrategy: action.payload,
        addAreaEntryStrategyError: null,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default addAreaEntryStrategy;
